































import { Vue, Component, Prop } from 'vue-property-decorator'
import { format } from 'quasar'
import store from 'src/assets/store'
import DeadlineTimer from 'components/DeadlineTimer.vue'
import { ItemTypeTopic, Session, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    DeadlineTimer
  }
})
export default class AttendeeSessionButtonNext extends Vue {
  pad = format.pad
  ItemTypeTopic = ItemTypeTopic
  timeprogress = 0

  @Prop()
  readonly session!: Session

  @Prop()
  readonly attendee!: SessionAttendee

  @Prop()
  readonly slides!: Json[]

  @Prop()
  readonly currSlideId!: number

  get currSlide () {
    return this.slides.find(x => x.id === this.currSlideId)
  }

  // get currSlideIndex () {
  //   return this.currSlide ? this.slides.indexOf(this.currSlide) + 1 : 0
  // }
  //
  // get progress () {
  //   return 100 * this.currSlideIndex / Math.max(1, this.slides.length)
  // }

  get currSlideResponse () {
    if (this.currSlide && this.attendee.data) {
      return this.attendee.data[ this.currSlide.id ] || { timems: 0 }
    }
    return { timems: 0 }
  }

  get slideTimeTotal () {
    return this.currSlide?.timer
  }

  get slideTimeLeft () {
    if (this.session.topic?.typeTopic === ItemTypeTopic.Quiz && this.session.data?.iterate) {
      if (this.currSlide?.timer) {
        return this.currSlide.timer - this.currSlideResponse.timems / 1000 - (store.now().getTime() - new Date(this.attendee.data.lastActiveAt).getTime()) / 1000
      }
    }
  }

  get slideTimer () {
    if (this.slideTimeTotal !== undefined && this.slideTimeLeft !== undefined) {
      return {
        start: new Date(Date.now() - (this.slideTimeTotal - this.slideTimeLeft) * 1000),
        end: new Date(Date.now() + this.slideTimeLeft * 1000)
      }
    } else {
      return {}
    }
  }

  timeover () {
    if (this.slideTimer.start) {
      this.next()
    }
  }

  next () {
    if (this.currSlide === this.slides[ this.slides.length - 1 ]) {
      this.$emit('finish')
    } else {
      this.$emit('next')
    }
  }
}
